import { Controller } from "@hotwired/stimulus";

export default class NestedFormController extends Controller {
  static targets = ["links", "template", "appendForm", "addButton"];

  connect() {
    this.wrapperClass = this.element.dataset.wrapperClass || "nested-fields";
  }

  add_association(event) {
    if (event?.isTrusted) {
      event.preventDefault();
      const quillElement = this.templateTarget.content.querySelector(
        "[data-controller=\"quill\"]"
      );
      delete quillElement.dataset.value;
      quillElement.innerHTML = "<p></p>";
      quillElement.classList.add("nested-ele");
      let content = this.templateTarget.innerHTML.replaceAll(
        "NEW_RECORD",
        Date.now()
      );

      const wrapper = document.createElement("div");
      wrapper.innerHTML = content;

      const selectedOptions = new Set(Array.from(
        this.element.querySelectorAll(".dropdown.share-post-options:first-child .form-check-input:checked")
      ).map(cb => cb.dataset.option));

      const checkboxes = wrapper.querySelectorAll(".dropdown.share-post-options .form-check-input");

      for (const cb of checkboxes) {
        cb.checked = selectedOptions.has(cb.dataset.option);
      }

      const selectedReplyOptions = new Set(Array.from(
        this.element.querySelectorAll(".reply-opt-select .form-check-input:checked")
      ).map(cb => cb.value));

      const replyCheckboxes = wrapper.querySelectorAll(".reply-opt-select .form-check-input");

      for (const cb of replyCheckboxes) {
        cb.checked = selectedReplyOptions.has(cb.value);
      }

      const display = wrapper.querySelector(".selected-value-display");
      if (display) {
        display.textContent = Array.from(replyCheckboxes)
          .filter(cb => cb.checked)
          .map(cb => cb.nextElementSibling.textContent.trim())
          .join(", ") || "Select Reply Options";
      }

      const shareTypesSpan = wrapper.querySelector(".share_types");
      if (shareTypesSpan) {
        shareTypesSpan.textContent = Array.from(checkboxes)
          .filter(cb => cb.checked)
          .map(cb => cb.nextElementSibling.textContent.trim())
          .join(", ") || "Select Share Options";
      }

      this.appendFormTarget.append(...wrapper.childNodes);
      const modal = document.querySelector("#addPostModal .modal-body");
      modal.scrollTo({
        top: modal.scrollHeight,
        behavior: "smooth"
      });
    } else {
      const time = Date.now();
      const quillElement = this.templateTarget.content.querySelector(
        "[data-controller=\"quill\"]"
      );
      const extra = event.target.dataset.extras;
      quillElement.dataset.value = extra;
      quillElement.innerHTML = `<p>${extra}</p>`;
      quillElement.classList.add("nested-ele");
      let content = this.templateTarget.innerHTML.replaceAll("NEW_RECORD", time);
      this.appendFormTarget.insertAdjacentHTML("beforeend", content);
      const progressCircle = document.getElementById("progressCircle" + time);
      const inputLength = Math.min(extra.length - 1, 280);
      const maxChars = 280;
      const progressPercentage = (inputLength / maxChars) * 100;

      const dashOffset = 100 - progressPercentage;
      try {
        setTimeout(() => {
          progressCircle.style.strokeDashoffset = dashOffset;
        }, 100);
      } catch {
        // Ignore:
      }
    }
    event.currentTarget.closest(".post_media").classList.add("d-none");
    let forms = document?.querySelectorAll("[data-controller='emoji']");
    if (forms.length == 6) {
      $(".add_child_post").remove();
    }
    this.updateAddChildButton();
  }

  remove_association(event) {
    event.preventDefault();
    const wrapper = event.target.closest(`.${this.wrapperClass}`);
    const wrapperDOM = this.wrapperClass === "post-form-wrapper" ? wrapper.querySelector(".nested-fields") : wrapper;
    const poll = wrapper.closest("[id^=\"post-poll-\"]");
    const form = wrapper.closest("form");
    const removedFields = poll ? Array.from(wrapper.querySelectorAll("input")) : [];

    if (poll) {
      if (wrapperDOM.dataset.newRecord === "true") {
        wrapper.remove();
      } else {
        wrapper.querySelector("input[name*='_destroy']").value = 1;
        wrapper.style.display = "none";
        wrapper.querySelector("input[type='text']").value = "";
      }
      this.toggleAddButton();
      this.refreshPollAfterRemoval(poll, form, removedFields);
      return;
    }

    // Was this form's post_media visible?
    const postMedia = wrapper.querySelector(".post_media");
    const wasVisible = postMedia && !postMedia.classList.contains("d-none");
    const currentTarget = event.target.closest(".post-form-wrapper");
    const mediaElement = currentTarget.previousElementSibling?.querySelector(".post_media");

    if (wrapperDOM.dataset.newRecord === "true") {
      wrapper.remove();
    } else {
      wrapper.querySelector("input[name*='_destroy']").value = 1;
      wrapper.style.display = "none";
      wrapper.querySelector("input[type='text']").value = "";
    }

    if (wasVisible) {
      if (mediaElement) {
        mediaElement.classList.remove("d-none");
      } else {
        this.element.closest("form")?.querySelector(".post_media")?.classList.remove("d-none");
      }
    }

    this.toggleAddButton();
    this.updateAddChildButton();
    if (poll) this.refreshPollAfterRemoval(poll, form, removedFields);
  }

  refreshPollAfterRemoval(poll, form, removedFields) {
    const validator = $(form).data("validator");
    const validation = this.application.getControllerForElementAndIdentifier(form, "form-validation");
    for (const field of removedFields) {
      validation?.clearValidationTimer(field);
      if (!validator) continue;
      delete validator.invalid[field.name];
      delete validator.submitted[field.name];
      delete validator.errorMap[field.name];
    }
    if (validator) {
      validator.errorList = validator.errorList.filter(error => !removedFields.includes(error.element));
    }
    $(poll).find("input[name*=\"[poll_options_attributes]\"][name$=\"[answer]\"]")
      .filter(":visible").each(function () { $(this).valid(); });
    const editor = poll.closest(".post-form-wrapper")?.querySelector("[data-controller~=\"quill\"]");
    if (editor) {
      this.application.getControllerForElementAndIdentifier(editor, "quill")?.updateContentState();
    }
    const scope = poll.closest("[data-controller~=\"submit-state\"]");
    if (scope) {
      this.application.getControllerForElementAndIdentifier(scope, "submit-state")?.updateSubmitState();
    }
  }

  addOption(event) {
    event.preventDefault();
    const content = this.templateTarget.innerHTML.replaceAll(
      "NEW_RECORD",
      Date.now()
    );
    const optionsCount = this.getVisibleOptionFieldsCount();
    if (optionsCount < 4) {
      const wrapper = document.createElement("div");
      wrapper.innerHTML = content;

      // Template contents are not translated, so reuse the live poll placeholder.
      const optionSelector = "input[name*=\"[poll_options_attributes]\"][name$=\"[answer]\"]";
      const existingOption = this.appendFormTarget.querySelector(optionSelector);
      const newOption = wrapper.querySelector(optionSelector);
      if (existingOption && newOption) {
        newOption.placeholder = existingOption.placeholder;
      }

      this.appendFormTarget.append(...wrapper.childNodes);
      this.toggleAddButton();
    }
  }

  getVisibleOptionFieldsCount() {
    return Array.from(
      this.appendFormTarget.querySelectorAll(".nested-fields")
    ).filter((element) => element.offsetParent !== null).length;
  }

  toggleAddButton() {
    if (!this.hasAddButtonTarget) return;

    const optionsCount = this.getVisibleOptionFieldsCount();
    if (optionsCount >= 4) {
      this.addButtonTarget.classList.add("d-none");
    } else {
      this.addButtonTarget.classList.remove("d-none");
    }
  }


  updateAddChildButton() {
    const postFormWrapper = this.element.querySelectorAll(`.${this.wrapperClass}`);
    const addChildLinks = this.appendFormTarget.querySelectorAll(".add_child_post");
    const hasLimitReached = postFormWrapper.length >= 25;

    for (const link of addChildLinks) {
      link.classList.toggle("disabled", hasLimitReached);
    }
    if (hasLimitReached) {
      Swal.fire({
        customClass: {
          popup:
            "swal-popup alert-sm-bg align-items-center justify-content-center w-100",
          htmlContainer: "text-black-paint text-white"
        },
        animation: false,
        html: "You can't add any more posts to this thread.",
        icon: "error",
        showCloseButton: true,
        buttonsStyling: false,
        showConfirmButton: false,
        timer: 3000
      });
    }
  }
}
